export default "__VITE_ASSET__OH2FWAzr__"